import type * as ents from '@attain-apps/entities'

/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  editingFunctionalUsage?: ents.extra.space.Functionalization[]
  error?: Error
  functionalUsage?: ents.extra.space.Functionalization[]
  isLoading: boolean
}

export namespace State {
  export const INITIAL: Readonly<State> = {
    editingFunctionalUsage: undefined,
    error: undefined,
    functionalUsage: undefined,
    isLoading: false,
  }

  /** Update a specific functionalization's percentage or add it if it doesn't exist */
  export function updateFunctionalization(
    state: State,
    update: ents.extra.space.Functionalization,
  ): State {
    const existing = state.editingFunctionalUsage ?? []
    const idx = existing.findIndex(f => f.functionId === update.functionId)

    // If found, replace it in place; otherwise append it to the list
    const updated = [...existing]
    if (idx >= 0) {
      updated.splice(idx, 1, update)
    } else {
      updated.push(update)
    }

    return {
      ...state,
      editingFunctionalUsage: updated,
    }
  }
}
